import { rejected, resolved } from '../../createAction';
import { GET_THEMES, SAVE_THEME } from './types';

const initialState = {
  themes: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case resolved(GET_THEMES):
      return {
        ...state,
        themes: payload.map((i) => ({
          hash: i.hash,
          name: i.theme_name,
          ...i.theme_info,
        })),
      };
    case resolved(SAVE_THEME): {
      const exists = state.themes.find((i) => i.hash === payload.hash);
      const newTheme = {
        hash: payload.hash,
        name: payload.theme_name,
        ...payload.theme_info,
      };
      if (exists) {
        return {
          ...state,
          themes: state.themes.map((i) => (i === exists ? newTheme : i)),
        };
      }
      return {
        ...state,
        themes: [...state.themes, newTheme],
      };
    }
    default:
      return state;
  }
};
